import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';
import { DialogTypes } from 'types/types';
import { useSetRecoilState } from 'recoil';
import { dialogState } from 'state';
import { Add } from '@mui/icons-material';
import useHasAccess from 'hooks/useHasAccess';
import { Permission } from 'state/permissionState';

export function UsersBar() {
  const openDialog = useSetRecoilState(dialogState);
  const { t } = useTranslation();
  const canCreateUser = useHasAccess([Permission.WRITE_USER]);
  const canCreateSubProject = useHasAccess([Permission.WRITE_SUBPROJECT]);

  return (
    <Box
      width="100%"
      display="flex"
      alignItems="center"
      flexDirection="row"
      justifyContent="end"
    >
      <Button
        size="small"
        variant="contained"
        sx={{ mr: 1 }}
        startIcon={<Add />}
        onClick={() =>
          openDialog({ isOpen: true, dialogType: DialogTypes.addUser })
        }
        disabled={!canCreateUser}
      >
        {t('home.appBar.createNewUser')}
      </Button>
      <Button
        variant="contained"
        size="small"
        disabled={!canCreateSubProject}
        onClick={() =>
          openDialog({ isOpen: true, dialogType: DialogTypes.addGroup })
        }
      >
        {t('home.appBar.manageSubProjects')}
      </Button>
    </Box>
  );
}
